import { Button, Form, Input, Popconfirm, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { deleteLeavePolicy, getAllLeaveAllocation, leaveAllocationAllUsers, updateLeavePolicy } from '../../redux/rtk/features/leavePolicy/leavePolicySlice';
import getCompanyIdFromToken from '../../utils/getCompanyIdFromToken';
import EditLeavePolicyModal from './editLeavePolicy';

const AllocatedLeave = () => {
    // const { list, loading } = useSelector((state) => state.leavePolicy);
    const { list = [], loading } = useSelector((state) => state.leavePolicy);
    const [loader, setLoader] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [searchName, setSearchName] = useState('');
    const [searchCode, setSearchCode] = useState('');
    const companyId = getCompanyIdFromToken();

    useEffect(() => {
        dispatch(getAllLeaveAllocation());
    }, [dispatch]);

    const handleDelete = (id) => {
        dispatch(deleteLeavePolicy(id))
            .then(() => {
                dispatch(getAllLeaveAllocation());
            })
            .catch((error) => {
                toast.error('Error in deleting leave policy');
            });
    };

    const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

    const handleEditClick = (record) => {
        setSelectedPolicy(record);
        setEditModalVisible(true);
    };

    const handleEditModalCancel = () => {
        setEditModalVisible(false);
        setSelectedPolicy(null);
    };

    const handleEditModalOk = (values) => {
        dispatch(updateLeavePolicy({ id: selectedPolicy.id, values }))
            .then(() => {
                setEditModalVisible(false);
                setSelectedPolicy(null);
                dispatch(getAllLeaveAllocation());
            })
            .catch((error) => {
                toast.error("Error updating policy");
            });
    };

    const handleLeaveAllocationClick = () => {
        setLoader(true);
        dispatch(leaveAllocationAllUsers({ company_id: companyId }))
            .then(() => {
                setLoader(false);
                dispatch(getAllLeaveAllocation()); // Refresh the allocations
            })
            .catch((error) => {
                setLoader(false);
                toast.error('Error in adding Leave Allocations. Try again.');
                console.log(error.message);
            });
    };

    // Filter data based on search inputs
    // const filteredList = list
    //     ? list.filter(item =>
    //         `${item.user.firstName} ${item.user.lastName}`.toLowerCase().includes(searchName.toLowerCase()) &&
    //         item.user.employeeId.toLowerCase().includes(searchCode.toLowerCase())
    //     )
    //     : [];

    // const filteredList = list
    //     ? list.filter(item =>
    //         `${item.user.firstName} ${item.user.lastName}`().includes(searchName) &&
    //         item.user.employeeId.includes(searchCode)
    //     )
    //     : [];

    const filteredList = list
    ? list.filter(item => {
        const firstName = item.user?.firstName || "";
        const lastName = item.user?.lastName || "";
        const employeeId = item.user?.employeeId || "";
        
        return `${firstName} ${lastName}`.toLowerCase().includes(searchName.toLowerCase()) &&
               employeeId.toLowerCase().includes(searchCode.toLowerCase());
    })
    : [];


    const columns = [
        {
            title: 'Employee Name',
            key: 'employeeName',
            // render: (_, record) => `${record.user.firstName} ${record.user.lastName}`,
            render: (_, record) => `${record.user?.firstName || ''} ${record.user?.lastName || ''}`.trim() || 'N/A',
        },
        {
            title: 'Employee Code',
            key: 'employeeCode',
            //   render: (_, record) => `${record.user.employeeId}`,
            render: (_, record) => record.user.employeeId || 'N/A',

        },
        {
            title: 'Leave Type',
            key: 'leaveType',
            render: (_, record) => record.leaveType?.leaveType || 'N/A',
        },
        {
            title: 'Annual Leave',
            dataIndex: 'annualLeave',
            key: 'annualLeave',
        },
        {
            title: 'Monthly Leave',
            dataIndex: 'monthlyLeave',
            key: 'monthlyLeave',
        },
        {
            title: 'Pending Leaves',
            dataIndex: 'pendingLeaves',
            key: 'pendingLeaves',
        },
    ];

    return (
        <>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <Popconfirm
                    title="Are you sure you want to allocate leaves to all users?"
                    onConfirm={handleLeaveAllocationClick}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        type="primary"
                        loading={loader}
                    >
                        Allocate Leave to All Users
                    </Button>
                </Popconfirm>

                <div style={{ display: 'flex', gap: '8px' }}>
                    <Input
                        placeholder="Search by Employee Name"
                        style={{ width: '200px' }}
                        value={searchName}
                        onChange={(e) => setSearchName(e.target.value)}
                    />
                    <Input
                        placeholder="Search by Employee Code"
                        style={{ width: '200px' }}
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                    />
                </div>
            </div>

            <Table columns={columns} dataSource={filteredList ? addKeys(filteredList) : []} />

            <EditLeavePolicyModal
                visible={editModalVisible}
                onCancel={handleEditModalCancel}
                onOk={handleEditModalOk}
                initialValues={selectedPolicy}
                leaveTypes={leaveTypes}
                loading={loading}
            />
        </>
    );
};

export default AllocatedLeave;
